export default __webpack_public_path__ + "0ca8ee04bbefab1ab2d7a02fbc08ab2c.woff";